<template>

	<a-card :bordered="false" class="widget-1" @click="onToUrl">
		<a-statistic
			:title="title"
			:value="value"
			:prefix="prefix"
			:suffix="suffix"
			:precision="0"
			class="text-success"
			:class="'text-' + status"
            v-number-increase
		>
		</a-statistic>
		<div class="icon" v-html="icon"></div>
	</a-card>

</template>

<script>
    import numberIncrease from '../../directives/numberIncrease';
	export default ({
		props: {
			title: {
				type: String,
				default: "",
			},
			value: {
				default: 0,
			},
			prefix: {
				type: String,
				default: "",
			},
			suffix: {
				type: String,
				default: "",
			},
			icon: {
				type: String,
				default: "",
			},
			status: {
				type: String,
				default: "success",
			},
            url: {
                type: String,
				default: "",
            }
		},
        directives: {
            numberIncrease,
        },
		data() {
			return {
			}
		},
        methods: {
            onToUrl() {
                if(!this.url) return
                this.$router.push(this.url);
            }
        }
	})

</script>